/**
 * Grid / row-filter helpers for values that look numeric but are identifiers (e.g. investor names).
 * `parseFloat("2020 Revocable Test One, LP")` === 2020 — never use loose parseFloat for display or equality.
 */

/** True only when the entire cell value is a plain decimal (not "2020 Fund Name"). */
export const isGridNumericCellValue = (value) => {
  if (typeof value === 'number') return Number.isFinite(value);
  if (typeof value !== 'string') return false;
  const t = value.trim();
  if (t === '') return false;
  return /^-?\d+(\.\d+)?$/.test(t);
};

export const parseGridNumericCellValue = (value) =>
  typeof value === 'number' ? value : parseFloat(String(value).trim());

/** Investor / fund / unnamed Excel index columns must stay text. */
export const isTextIdentifierField = (fieldName) => {
  if (!fieldName) return false;
  const lower = String(fieldName).toLowerCase();
  return (
    lower.includes('investor') ||
    lower.includes('fund_name') ||
    lower.includes('fundname') ||
    lower.startsWith('unnamed')
  );
};

/** Row dropdown / COMPARE record matching — exact text match; numeric only when both sides are plain numbers. */
export const valuesMatchForRowFilter = (left, right) => {
  if (left === right) return true;
  if (left == null || right == null) return false;

  const leftStr = String(left).trim();
  const rightStr = String(right).trim();
  if (leftStr === rightStr) return true;

  if (isGridNumericCellValue(left) && isGridNumericCellValue(right)) {
    return parseGridNumericCellValue(left) === parseGridNumericCellValue(right);
  }

  return false;
};
